import React from 'react';

import { styled } from '@this/constants/themes';
import { media } from '@this/src/components/shared/atoms/media';
import StayPlanWarning from '@this/src/components/reserve_trip/select/shared/stay_plan_warning';

export interface Translatedline {
  label: string;
  value: string;
  translate: boolean;
  restricted?: boolean;
}

interface Props {
  line: Translatedline;
}

const TripCardHotelTypeLine: React.FC<Props> = ({ line }) => {
  return line.restricted ? (
    <RestrictedWrapper>
      <LineText line={line} />
      <StayPlanWarning variant="text" restricted />
    </RestrictedWrapper>
  ) : (
    <LineText line={line} />
  );
};

const LineText: React.FC<Props> = ({ line }) => {
  return line.translate ? <TranslatedText line={line} /> : <UnTranslatedText line={line} />;
};

const TranslatedText: React.FC<Props> = ({ line }) => {
  return (
    <Text>
      <span>{line.label}</span>
      <span>{line.value}</span>
    </Text>
  );
};

const UnTranslatedText: React.FC<Props> = ({ line }) => {
  return (
    <Text>
      <span>{line.label}</span>
      <span data-wovn-ignore>{line.value}</span>
    </Text>
  );
};

const RestrictedWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 2px 0;
  line-height: normal;

  ${media.sp`
    flex-direction: column;
    gap: 2px;
  `}
`;

const Text = styled.div``;

export default TripCardHotelTypeLine;
